import { createApp } from "vue";
import App from "./App.vue";
// import TDesign from "tdesign-vue-next/esm";
import i18n from "../i18n";
import { TaskType } from "./types";

export const defaultGlobalConfig = {
  classPrefix: "flow-t",
};

export type GraphConfig = {
  // 节点的默认配置
  node?: {
    /**
     * 节点类型列表，会渲染到左上角
     */
    nodeList: Array<{
      // 节点类型
      type: string;
      id?: string;
      name?: string;
      icon?: string;
      pIcon?: string;
      bgColor?: string;
      width?: number;
      height?: number;
      [k: string]: any;
    }>;
    /**
     * 起点的类型，从 nodeList 选择
     *
     * 起点只有一个出口，在 node 的下方
     */
    startNodeType: string;
    [k: string]: any;
  };
  edge?: object;
  // 传给 x6 的配置
  g6Config?: object;
  minimap?: object | boolean;
  [k: string]: any;
};

export const init = (
  graphConfig: GraphConfig,
  taskType: TaskType = TaskType.NORMAL,
) => {
  const app = createApp(App, {
    gConfig: graphConfig,
    taskType,
  });
  // app.use(TDesign);
  app.use(i18n);
  return app;
};
